import * as types from '../actions/action-types';

export function addUploads(files) {
    return {
        type: types.ADD_UPLOADS,
        files
    };
}

export function deleteUpload(tempUUID) {
    return {
        type: types.DELETE_UPLOAD,
        tempUUID
    };
}

export function clearUploads() {
    return {
        type: types.CLEAR_UPLOADS
    };
}

export function setUploadData(uploadData) {
    return {
        type: types.SET_UPLOAD_DATA,
        data: uploadData
    };
}

export function deleteKeyword(keyword) {
    return {
        type: types.DELETE_KEYWORD,
        keyword
    };
}

